import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationLinear: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconAnimationLinear"><Path fillRule="evenodd" clipRule="evenodd" d="M20.8536 3.14645C21.0488 3.34171 21.0488 3.65829 20.8536 3.85355L3.85355 20.8536C3.65829 21.0488 3.34171 21.0488 3.14645 20.8536C2.95118 20.6583 2.95118 20.3417 3.14645 20.1464L20.1464 3.14645C20.3417 2.95118 20.6583 2.95118 20.8536 3.14645Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnimationLinear;
